/* eslint-disable global-require */
const warehouseList = {
  BIGQUERY: require('./BIGQUERY.json'),
  CLICKHOUSE: require('./CLICKHOUSE.json'),
  POSTGRES: require('./POSTGRES.json'),
  REDSHIFT: require('./REDSHIFT.json'),
  AZURE_SYNAPSE: require('./AZURE_SYNAPSE.json'),
  SNOWFLAKE: require('./SNOWFLAKE.json'),
  S3: require('./S3.json'),
  MYSQL: require('./MYSQL.json'),
  DATABRICKS: require('./DATABRICKS.json'),
};
const WAREHOUSE_DOC_LINKS = {
  visualDataMapper:
    'https://www.rudderstack.com/docs/reverse-etl/features/visual-data-mapper/#using-the-visual-data-mapper',
  syncScheduleSettings:
    'https://www.rudderstack.com/docs/reverse-etl/common-settings/sync-schedule-settings/#sync-schedule-settings',
  syncModes: 'https://www.rudderstack.com/docs/reverse-etl/common-settings/sync-modes/',
  sqlModelSetup:
    'https://www.rudderstack.com/docs/reverse-etl/features/models/#creating-a-new-model',
  tableOrModel:
    'https://www.rudderstack.com/docs/reverse-etl/faq/#what-is-the-difference-between-the-table-and-model-options-when-creating-a-reverse-etl-source',
  sqlModelCompleteGuide: 'https://www.rudderstack.com/docs/reverse-etl/features/models/',
};

export { warehouseList, WAREHOUSE_DOC_LINKS };
